export const enum ScoreType {
    thumbs = "thumbs",
    score = "score"
}


// WEBPACK FOOTER //
// ./src/Models/Audit/ScoreType.ts